import React from "react";
import { Navigate, Route, Routes } from "react-router-dom"; // Removed BrowserRouter import
import Myaccount from "../pages/myaccount/Myaccount";
import Header from "../components/common/header/Header";
import Breadcrumbs from "../components/common/breadcrumbs/Breadcrumbs";
import Home from "../pages/home/Home";
import Myprofile from "../pages/myaccount/myprofile/Myprofiletab";
import Chattab from "../pages/myaccount/chat/Chattab";
import Subscriptiontab from "../pages/myaccount/subscriptions/Subscriptiontab";
import AdsTab from "../pages/myaccount/ads/Adstab";
import FavoriteTab from "../pages/myaccount/favorites/Favoritestab";
import OrdersTab from "../pages/myaccount/orders/Orderstab";
import Healthandfitness from "../pages/health&fitness/Healthandfitness";
import Dashboardtab from "../pages/health&fitness/dashboardtab/Dashboardtab";
import Goalsettingstab from "../pages/health&fitness/goalsetting/Goalsettingtab";
import Medicalappointmenttab from "../pages/health&fitness/medicalappoinmet/Medicalappoinmenttab";
import Organizefinance from "../pages/organizefinance/Organizefinance";
import Accountoverview from "../pages/organizefinance/accountoverview/Accountoverview";
import TransactionTab from "../pages/organizefinance/transaction/Transactiontab";
import BudgettingTab from "../pages/organizefinance/budgetting/BudgettingTab";
import ReportTab from "../pages/organizefinance/reports/Reportstab";
import ClassSchedulesTab from "../pages/organizeclasses/classschedules/ClassScheduletab";
import OrganizeClasses from "../pages/organizeclasses/Organizeclasses";
import ExtraClassesTab from "../pages/organizeclasses/extraclasses/Extraclassestab";
import StudyGroupTab from "../pages/organizeclasses/studygroup/Studygroup";
import CampusandCommunity from "../pages/campus&comunity/Campusandcommunity";
import Eventstab from "../pages/campus&comunity/events/Events";
import VolenteerTab from "../pages/campus&comunity/volunteeroppertunity/Volunteeroppertunity";
import ParticipantsPage from '../pages/campus&comunity/volunteeroppertunity/ParticipantsPage';
import ClubsTab from "../pages/campus&comunity/clubs/Clubs";
import MarketPlaceTab from "../pages/marketplace/MarketPlaceTab";
import MarketplaceDetailsPage from '../pages/marketplace/MarketplaceDetailsPage';
import AdsDetailsPage from "../pages/myaccount/ads/AdsDetailsPage";
import CreateAdPage from "../pages/myaccount/ads/CreateAdPage";
import EditAdPage  from "../pages/myaccount/ads/EditAdPage";
import ParticipantsList from "../pages/campus&comunity/events/participantslist";
import TodoList from '../pages/studenttools/todolist/TodoList';
import Noteslist from '../pages/studenttools/notes/Noteslist';
import QuickLinksTab from '../pages/studenttools/quicklinks/QuickLinksTab';
import Jobslist from '../pages/studenttools/jobs/Jobslist';
import Dealslist from '../pages/studenttools/deals/Dealslist';
import Planner from '../pages/studenttools/planner/Planner';
import Forums from "../pages/campus&comunity/forums/Forums";
import FavoritesDetailsPage from '../pages/myaccount/favorites/FavoritesDetailsPage';
 
const Postlogin = () => {
    return (
        <div className="overflow-x-hidden">
            <Header />
 
            <div className="mainpanel">
                <div className="container">
                    <div className="css-11ezll3-MuiToolbar-root breadcrumbs">
                        <Breadcrumbs />
                    </div>
                </div>
 
                <div className="sub-nav">
                    <Routes>
                        <Route path="/" element={<Navigate to="/home" />} />
                        <Route path="/home" element={<Home />} />
                        <Route path="/marketplace" element={<MarketPlaceTab />} />
                        
                        {/* FIXED: Added both marketplace detail routes */}
                        <Route path="/marketplace/:id" element={<MarketplaceDetailsPage />} />
                        <Route path="/marketplace/:id/:slug" element={<MarketplaceDetailsPage />} />
                        
                        <Route path="/myaccount" element={<Myaccount />}>
                            <Route path="myprofile" element={<Myprofile />} />
                            <Route path="chat" element={<Chattab />} />
                            <Route path="subscription" element={<Subscriptiontab />} />
                            <Route path="/myaccount/mylisting/" element={<AdsTab />} />
                            <Route path="favorite" element={<FavoriteTab />} />
                            <Route path="orders" element={<OrdersTab />} />
                        </Route>
                        <Route path="/healthandfitness" element={<Healthandfitness />}>
                            <Route path="dashboard" element={<Dashboardtab />} />
                            <Route path="goalsetting" element={<Goalsettingstab />} />
                            <Route path="medicalappointments" element={<Medicalappointmenttab />} />
                        </Route>
                        <Route path="/organizefinance" element={<Organizefinance />}>
                            <Route path="accountoverview" element={<Accountoverview />} />
                            <Route path="transaction" element={<TransactionTab />} />
                            <Route path="budgetting" element={<BudgettingTab />} />
                            <Route path="report" element={<ReportTab />} />
                        </Route>
                        <Route path="/organizeclasses" element={<OrganizeClasses />}>
                            <Route path="classschedules" element={<ClassSchedulesTab />} />
                            <Route path="extraclasses" element={<ExtraClassesTab />} />
                            <Route path="studygroup" element={<StudyGroupTab />} />
                        </Route>
                        <Route path="/campusandcommunity" element={<CampusandCommunity />}>
                            <Route path="events" element={<Eventstab />} />
                            <Route path="volunteeroppertunities" element={<VolenteerTab />} />
                            <Route path="clubs" element={<ClubsTab />} />
                        </Route>
                        <Route path="/events/:eventId/participants" element={<ParticipantsList />} />
                        <Route path="/myaccount/mylisting/adsdetails/:id" element={<AdsDetailsPage />} />
                        <Route path="/myaccount/mylisting/create" element={<CreateAdPage />} />
                        <Route path="/myaccount/mylisting/edit/:id" element={<EditAdPage />} />
                        <Route path="/studenttools/todolist" element={<TodoList />} />
                        <Route path="/studenttools/notes" element={<Noteslist />} />
                        <Route path="/studenttools/quicklinks" element={<QuickLinksTab />} />
                        <Route path="/studenttools/jobs" element={<Jobslist />} />
                        <Route path="/studenttools/deals" element={<Dealslist />} />
                        <Route path="/studenttools/planner" element={<Planner />} />
                        <Route path="/opportunities/:id/participants" element={<ParticipantsPage />} />
                        <Route path="/campusandcommunity/forums" element={<Forums />} />
                        <Route path="/myaccount/favorites/details/:id" element={<FavoritesDetailsPage />} />
                        
                        {/* MOVED: Catch-all route to the very end */}
                        <Route path="*" element={<Navigate to="/home" replace />} />
                    </Routes>
                </div>
            </div>
        </div>
    );
};
 
export default Postlogin;